import { fork, call, put, select, all, takeEvery } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import isEmpty from 'lodash/isEmpty';
import * as api from '../services/apiAdmin';
import { processCSVImport } from '../services/apiAdmin';
import { deleteDeviceSaga, deleteDeviceFromListSaga, fetchDeviceForEditSaga, saveDeviceSaga, fetchListDeviceSaga } from './device/saga_device';

import * as common from './sagasCommon';
import item_group_price_sagas from './item_group_price/saga_item_group_price';
import item_number_type_sagas from './item_number_type/saga_item_number_type';
import loyalty_redemption_sagas from './loyalty/saga_loyalty_redemption';
import order_management_control_records_sagas from './order_management/saga_order_management_control_records';
import order_management_sagas from './order_management/saga_order_management';
import order_group_sagas from './order_group/saga_order_group';
import shipping_method_sagas from './shipping_method/saga_shipping_method';
import * as subsidiary_sagas from './subsidiary/sagasSubsidiary';
import * as pricebook_sagas from './pricebook/saga_price_book';
import * as location_sagas from './location/sagasLocation';
import * as hotkey_group_sagas from './hotkey_group/saga_hotkey_group';
import * as hotkey_template_sagas from './hotkey_template/saga_hotkey_template';
import * as devicetype_sagas from './device_type/saga_device_type';
import * as payment_type_sagas from './payment_type/saga_payment_type';
import * as pricelevel_sagas from './price_level/saga_price_level';
import * as reasoncode_sagas from './reason_code/saga_reason_code';
import * as tasktype_sagas from './task_type/saga_task_type';
import * as season_sagas from './season/saga_season';
import * as group_type_sagas from './group_type/saga_group_type';
import * as cashrounding_sagas from './cash_rounding/saga_cash_rounding';
import * as currency_sagas from './currency/saga_currency';
import * as addresstype_sagas from './address_type/saga_address_type';
import * as relatedentity_sagas from './related_entity_type/saga_related_entity_type';
import * as employee_sagas from './employee/saga_employee';
import * as custom_field_sagas from './custom_field/saga_custom_field';
import * as custom_form_sagas from './custom_form/saga_custom_form';
import * as custom_tab_sagas from './custom_tab/saga_custom_tab';
import * as custom_field_list_sagas from './list/saga_list';
import * as customer_sagas from './customer/saga_customer';
import * as item_sagas from './item/sagaItem';
import * as item_location_sagas from './item/saga_item_location';
import * as tax_code_sagas from './tax/sagasTaxCode';
import * as tax_exempt_type_sagas from './tax/sagaTaxExemptType';
import * as tax_type_sagas from './tax/sagaTaxType';
import * as tax_group_sagas from './tax/sagaTaxGroup';
import * as contact_sagas from './contact/saga_contact';
import * as brand_sagas from './brand/saga_brand';
import * as matrixattribute_sagas from './item/sagaMatrixAttribute';
import * as matrixchildren_sagas from './item/sagaMatrixChildren';
import * as preference_sagas from './preferences/saga_preferences';
import * as supplier_sagas from './supplier/saga_supplier';
import * as attribute_name_sagas from './item/sagaAttributeName';
import * as attribute_value_sagas from './item/sagaAttributeValue';
import * as list_sagas from './sagasList';
import * as facet_sagas from './facet/saga_facet';
import * as credit_type_sagas from './credit_type/saga_credit_type';
import * as print_template_sagas from './print_template/saga_print_template';
import * as promotion_sagas from './promotion/saga_promotion';
import * as task_sagas from './task/sagasTask';
import * as exchange_rate_sagas from './exchange_rate/saga_exchange_rate';
import * as reporting_exchange_rate_sagas from './reporting_exchange_rate/saga_reporting_exchange_rate';
import * as shift_type_sagas from './shift_type/saga_shift_type';
import * as roles_sagas from './roles/saga_roles';
import * as sale_transaction_sagas from './sale_transaction/sagas_sale_transaction';
import * as purchase_order_sagas from './purchase/order/sagas_purchase_order';
import * as purchase_receipt_sagas from './purchase/receipt/sagas_purchase_receipt';
import * as inventory_return_sagas from './purchase/return/saga_inventory_return';
import * as inventory_stocktake_sagas from './inventory/stocktake/saga_inventory_stocktake';
import * as matrix_child_sagas from './item/saga_matrix_child';
import * as price_group_sagas from './price_group/saga_price_group';
import unit_of_measure_type_sagas from './unit_of_measure_type/saga_unit_of_measure_type';
import item_uom_sagas from './item/saga_item_uom';
import labelPrintSagas from './label_print/sagas_label_print';
import event_sagas from './event/saga_event';
import shortcut_sagas from './shortcut/sagas_shortcut';
import budgetSagas from './budget/saga_budget';

import * as barcode_sagas from './saga_barcode';


import * as classification_sagas from './classification/saga_classification';
import * as initialize_sagas from './initialize/sagas_initialize';
import * as region_sagas from './region/saga_region';
import * as job_sagas from './job/saga_job';
import * as system_notes_sagas from './system_notes/saga_system_notes';
import RecordSagas from './record/saga_record';
import ReportSagas from './report/saga_report';
import DashboardSagas from './dashboard/saga_dashboard';
import CSVSagas from './csv_record/saga_csv_record';
import GlobalSearchSagas from './global_search/saga_global_search';
import CSVExportSagas from './csv_export/saga_csv_export';
import ExportTransactionSagas from './export_transaction/saga_export_transaction';
import StoreSummarySagas from './store_summary/saga_store_summary';
import ApiCredentialSagas from './api_credential/saga_api_credential';

import * as inventory_transfer_sagas from './inventory/transfer/saga_inventory_transfer';
import * as inventory_adjustment_sagas from './inventory/adjustment/saga_inventory_adjustment';

import * as DocType from '../constants/constant_doc_types';
import * as TransactionStatus from '../constants/constant_transaction_status';
import * as InventoryStatus from '../constants/constant_inventory_status';
import * as ActionType from '../constants/constant_action_types';
import * as DeviceStatus from '../constants/constant_device_status';


import * as country_sagas from './country/saga_country';
import * as dropdown_sagas from './dropdown/sagasDropdown';

import * as loggingSagas from './logging/sagas_logging';
import addressSearchSagas from '../components/common/form/fields/address_search/AddressSearchFieldSaga';
import { sagas as dropdownSagas } from '../components/common/form/fields/dropdown_search';
import { sagas as tyroSagas } from '../tyro';
import { sagas as hotkeyTemplateSagas } from '../components/admin/hotkey_template';

import * as payment_transaction_sagas from './payment_transaction/saga_payment_transaction';

import * as entity_purchase_order_sagas from './entity_purchase/saga_entity_purchase_order';
import * as entity_purchase_receipt_sagas from './entity_purchase/saga_entity_purchase_receipt';
import * as entity_inventory_return_sagas from './entity_purchase/saga_entity_inventory_return';
import * as credit_certificate_sagas from './credit_certificate/saga_credit_certificate';
import KafkaLogSagas from './kafka_log/saga_kafka_log';
import ListsSagas from './saga_list';
import ereceiptSagas from './ereceipt/saga_ereceipt';
import spiSagas from '../spi/sagas';
import xeroSagas from './xero/saga_xero';
import integrationSagas from './integration/saga_integration';

import messagesCommon from '../components/common/translation_common';

import { getStatusList } from '../components/admin/device/form/DeviceSelector';
import { getPrimarySubsidiary } from '../common/selectors/selector_common';
import { email, sms } from '../services/apiCommon';
import { getAllPurchaseOrderLinesItemLocation } from '../actions/actionCreatorsPurchase';

function* processCSVImportSaga(app) {
  yield takeEvery('PROCESS_CSV_IMPORT', callProcessCSVImport, app);
}

function* callProcessCSVImport(app, action) {
  yield call(processCSVImport, app, action);
}

function forkAutoRestarting(fn, ...args) {
  return fork(function* () {
    yield call(fn, ...args);
  });
}

export default function* root(app) {
  yield all([
    forkAutoRestarting(tyroSagas),
    forkAutoRestarting(hotkeyTemplateSagas, app), // Previously app

    forkAutoRestarting(addressSearchSagas, app),
    forkAutoRestarting(dropdownSagas, app),

    forkAutoRestarting(processCSVImportSaga, app), // Previously app
    forkAutoRestarting(initializePouchDatabaseSaga, app), // Previously app
    forkAutoRestarting(listSetupDataSaga, app), // Previously app
    forkAutoRestarting(saveAsSaga, app),
    forkAutoRestarting(fetchDataByIdSaga, app),

    forkAutoRestarting(deleteDeviceSaga, app),
    forkAutoRestarting(deleteDeviceFromListSaga, app),
    forkAutoRestarting(fetchDeviceForEditSaga, app),
    forkAutoRestarting(saveDeviceSaga, app),
    forkAutoRestarting(fetchListDeviceSaga, app),

    forkAutoRestarting(findTransactionByLocationSaga, app), // Previously app

    forkAutoRestarting(employee_sagas.fetchListEmployeeSaga, app),
    forkAutoRestarting(employee_sagas.deleteEmployeeFromListSaga, app),
    forkAutoRestarting(employee_sagas.saveEmployeeSaga, app),
    forkAutoRestarting(employee_sagas.deleteEmployeeSaga, app),
    forkAutoRestarting(employee_sagas.fetchEmployeeForEditSaga, app),
    forkAutoRestarting(employee_sagas.changeEmployeePasswordSaga, app), // Previously app
    forkAutoRestarting(employee_sagas.changeEmployeePinSaga, app), // Previously app
    forkAutoRestarting(employee_sagas.emailEmployeePinSaga, app),
    forkAutoRestarting(employee_sagas.smsEmployeePinSaga, app),

    forkAutoRestarting(custom_field_sagas.fetchListCustomFieldSaga, app),
    forkAutoRestarting(custom_field_sagas.fetchCustomFieldForEditSaga, app),
    forkAutoRestarting(custom_field_sagas.saveCustomFieldSaga, app),
    forkAutoRestarting(custom_field_sagas.deleteCustomFieldSaga, app),
    forkAutoRestarting(custom_field_sagas.getCustomFieldTabSettingLinesSaga),

    forkAutoRestarting(custom_form_sagas.deleteCustomFormSaga, app),
    forkAutoRestarting(custom_form_sagas.fetchCustomFormForEditSaga, app),
    forkAutoRestarting(custom_form_sagas.fetchListCustomFormSaga, app),
    forkAutoRestarting(custom_form_sagas.getCustomFormDataSaga, app),
    forkAutoRestarting(custom_form_sagas.getCustomFormTabSettingLinesSaga),
    forkAutoRestarting(custom_form_sagas.saveCustomFormSaga, app),
    forkAutoRestarting(custom_form_sagas.setCustomFromFieldValue),

    forkAutoRestarting(custom_tab_sagas.fetchListCustomTabSaga, app),
    forkAutoRestarting(custom_tab_sagas.fetchCustomTabForEditSaga, app),
    forkAutoRestarting(custom_tab_sagas.saveCustomTabSaga, app),
    forkAutoRestarting(custom_tab_sagas.deleteCustomTabSaga, app),
    forkAutoRestarting(custom_tab_sagas.getCustomTabCustomFieldsSaga, app),
    forkAutoRestarting(custom_tab_sagas.getCustomTabCustomFormsSaga, app),

    forkAutoRestarting(custom_field_list_sagas.fetchListRecordsSaga, app),
    forkAutoRestarting(custom_field_list_sagas.fetchListForEditSaga, app),
    forkAutoRestarting(custom_field_list_sagas.saveListSaga, app),
    forkAutoRestarting(custom_field_list_sagas.deleteListSaga, app),

    forkAutoRestarting(customer_sagas.fetchListCustomerSaga, app),
    forkAutoRestarting(customer_sagas.deleteCustomerFromListSaga, app),
    forkAutoRestarting(customer_sagas.saveCustomerSaga, app),
    forkAutoRestarting(customer_sagas.deleteCustomerSaga, app),
    forkAutoRestarting(customer_sagas.fetchCustomerForEditSaga, app),
    forkAutoRestarting(customer_sagas.getCustomerSaleTransactions, app),
    forkAutoRestarting(customer_sagas.getCustomerPayments, app),

    forkAutoRestarting(hotkey_template_sagas.fetchListHotkeyTemplateSaga, app),
    forkAutoRestarting(hotkey_template_sagas.deleteHotkeyTemplateFromListSaga, app),
    forkAutoRestarting(hotkey_template_sagas.deleteHotkeyTemplateSaga, app),
    forkAutoRestarting(hotkey_template_sagas.fetchHotkeyTemplateForEditSaga, app),

    forkAutoRestarting(pricebook_sagas.fetchListPriceBookSaga, app),
    forkAutoRestarting(pricebook_sagas.fetchPriceBookForRenewSaga, app),
    forkAutoRestarting(pricebook_sagas.deletePricebookFromListSaga, app),
    forkAutoRestarting(pricebook_sagas.savePriceBookSaga, app),
    forkAutoRestarting(pricebook_sagas.deletePricebookSaga, app),
    forkAutoRestarting(pricebook_sagas.fetchPriceBookForEditSaga, app),
    forkAutoRestarting(pricebook_sagas.getPriceBookItemLocation, app),
    forkAutoRestarting(pricebook_sagas.getTaxCodes, app),

    forkAutoRestarting(subsidiary_sagas.fetchListSubsidiarySaga, app),
    forkAutoRestarting(subsidiary_sagas.deleteSubsidiaryFromListSaga, app),
    forkAutoRestarting(subsidiary_sagas.saveSubsidiarySaga, app),
    forkAutoRestarting(subsidiary_sagas.deleteSubsidiarySaga, app),
    forkAutoRestarting(subsidiary_sagas.fetchSubsidiaryForEditSaga, app),
    forkAutoRestarting(subsidiary_sagas.setHeaderbarSubsidiarySaga, app),
    forkAutoRestarting(subsidiary_sagas.setPrimarySubsidiarySaga, app),

    forkAutoRestarting(devicetype_sagas.fetchListDeviceTypeSaga, app),
    forkAutoRestarting(devicetype_sagas.saveDeviceTypeSaga, app),
    forkAutoRestarting(devicetype_sagas.deleteDeviceTypeFromListSaga, app),
    forkAutoRestarting(devicetype_sagas.deleteDeviceTypeSaga, app),
    forkAutoRestarting(devicetype_sagas.fetchDeviceTypeForEditSaga, app),

    forkAutoRestarting(payment_type_sagas.fetchListPaymentTypeSaga, app),
    forkAutoRestarting(payment_type_sagas.deletePaymentTypeFromListSaga, app),
    forkAutoRestarting(payment_type_sagas.savePaymentTypeSaga, app),
    forkAutoRestarting(payment_type_sagas.deletePaymentTypeSaga, app),
    forkAutoRestarting(payment_type_sagas.fetchPaymentTypeForEditSaga, app),

    forkAutoRestarting(pricelevel_sagas.fetchListPriceLevelSaga, app),
    forkAutoRestarting(pricelevel_sagas.deletePriceLevelFromListSaga, app),
    forkAutoRestarting(pricelevel_sagas.savePriceLevelSaga, app),
    forkAutoRestarting(pricelevel_sagas.deletePriceLevelSaga, app),
    forkAutoRestarting(pricelevel_sagas.fetchPriceLevelForEditSaga, app),

    forkAutoRestarting(reasoncode_sagas.fetchListReasonCodeSaga, app),
    forkAutoRestarting(reasoncode_sagas.deleteReasonCodeFromListSaga, app),
    forkAutoRestarting(reasoncode_sagas.saveReasonCodeSaga, app),
    forkAutoRestarting(reasoncode_sagas.deleteReasonCodeSaga, app),
    forkAutoRestarting(reasoncode_sagas.fetchReasonCodeForEditSaga, app),

    forkAutoRestarting(tasktype_sagas.fetchListTaskTypeSaga, app),
    forkAutoRestarting(tasktype_sagas.deleteTaskTypeFromListSaga, app),
    forkAutoRestarting(tasktype_sagas.saveTaskTypeSaga, app),
    forkAutoRestarting(tasktype_sagas.deleteTaskTypeSaga, app),
    forkAutoRestarting(tasktype_sagas.fetchTaskTypeForEditSaga, app),


    forkAutoRestarting(season_sagas.fetchListSeasonSaga, app),
    forkAutoRestarting(season_sagas.deleteSeasonFromListSaga, app),
    forkAutoRestarting(season_sagas.saveSeasonSaga, app),
    forkAutoRestarting(season_sagas.deleteSeasonSaga, app),
    forkAutoRestarting(season_sagas.fetchSeasonForEditSaga, app),

    forkAutoRestarting(group_type_sagas.fetchListGroupTypeSaga, app),
    forkAutoRestarting(group_type_sagas.deleteGroupTypeFromListSaga, app),
    forkAutoRestarting(group_type_sagas.saveGroupTypeSaga, app),
    forkAutoRestarting(group_type_sagas.deleteGroupTypeSaga, app),
    forkAutoRestarting(group_type_sagas.fetchGroupTypeForEditSaga, app),

    forkAutoRestarting(facet_sagas.fetchListFacetSaga, app),
    forkAutoRestarting(facet_sagas.deleteFacetFromListSaga, app),
    forkAutoRestarting(facet_sagas.saveFacetSaga, app),
    forkAutoRestarting(facet_sagas.deleteFacetSaga, app),
    forkAutoRestarting(facet_sagas.fetchFacetForEditSaga, app),

    forkAutoRestarting(cashrounding_sagas.fetchListCashRoundingSaga, app),
    forkAutoRestarting(cashrounding_sagas.deleteCashRoundingFromListSaga, app),
    forkAutoRestarting(cashrounding_sagas.saveCashRoundingSaga, app),
    forkAutoRestarting(cashrounding_sagas.deleteCashRoundingSaga, app),
    forkAutoRestarting(cashrounding_sagas.fetchCashRoundingForEditSaga, app),

    forkAutoRestarting(currency_sagas.fetchListCurrencySaga, app),
    forkAutoRestarting(currency_sagas.deleteCurrencyFromListSaga, app),
    forkAutoRestarting(currency_sagas.saveCurrencySaga, app),
    forkAutoRestarting(currency_sagas.deleteCurrencySaga, app),
    forkAutoRestarting(currency_sagas.fetchCurrencyForEditSaga, app),

    forkAutoRestarting(hotkey_group_sagas.fetchHotKeyGroupForEditSaga, app),
    forkAutoRestarting(hotkey_group_sagas.fetchHotKeyGroupItemsSaga, app),
    forkAutoRestarting(hotkey_group_sagas.saveHotKeyGroupSaga, app),
    forkAutoRestarting(hotkey_group_sagas.fetchListHotkeyGroupSaga, app),
    forkAutoRestarting(hotkey_group_sagas.deleteHotkeyGroupFromListSaga, app),
    forkAutoRestarting(hotkey_group_sagas.deleteHotkeyGroupSaga, app),

    forkAutoRestarting(location_sagas.fetchListLocationSaga, app),
    forkAutoRestarting(location_sagas.deleteLocationFromListSaga, app),
    forkAutoRestarting(location_sagas.saveLocationSaga, app),
    forkAutoRestarting(location_sagas.deleteLocationSaga, app),
    forkAutoRestarting(location_sagas.fetchLocationForEditSaga, app),
    forkAutoRestarting(location_sagas.massCreateItemsSaga, app), // Previously app

    forkAutoRestarting(addresstype_sagas.fetchListAddressTypeSaga, app),
    forkAutoRestarting(addresstype_sagas.deleteAddressTypeFromListSaga, app),
    forkAutoRestarting(addresstype_sagas.saveAddressTypeSaga, app),
    forkAutoRestarting(addresstype_sagas.deleteAddressTypeSaga, app),
    forkAutoRestarting(addresstype_sagas.fetchAddressTypeForEditSaga, app),

    forkAutoRestarting(relatedentity_sagas.fetchListRelatedEntityTypeSaga, app),
    forkAutoRestarting(relatedentity_sagas.deleteRelatedEntityTypeFromListSaga, app),
    forkAutoRestarting(relatedentity_sagas.saveRelatedEntityTypeSaga, app),
    forkAutoRestarting(relatedentity_sagas.deleteRelatedEntityTypeSaga, app),
    forkAutoRestarting(relatedentity_sagas.fetchRelatedEntityTypeForEditSaga, app),

    forkAutoRestarting(item_sagas.fetchListItemSaga, app),
    forkAutoRestarting(item_sagas.deleteItemSaga, app),
    forkAutoRestarting(item_sagas.deleteItemFromListSaga, app),
    forkAutoRestarting(item_sagas.saveItemSaga, app),
    forkAutoRestarting(item_sagas.fetchItemForEditSaga, app),
    forkAutoRestarting(item_sagas.addBarcodetoListSaga, app),
    forkAutoRestarting(item_sagas.addQRcodetoListSaga, app),
    forkAutoRestarting(item_sagas.getItemHotkeyGroups, app),

    forkAutoRestarting(barcode_sagas.findMatchItemValue, app),


    forkAutoRestarting(item_location_sagas.saveItemLocationSaga, app),
    forkAutoRestarting(item_location_sagas.getItemLocationsSaga, app),
    forkAutoRestarting(item_location_sagas.deleteItemLocationSaga, app),
    forkAutoRestarting(item_location_sagas.getItemLocationSaga, app),
    forkAutoRestarting(item_location_sagas.initializeDefaultItemLocationSaga, app),
    forkAutoRestarting(item_location_sagas.applyToAllItemLocationSaga, app),




    forkAutoRestarting(list_sagas.fetchProductTypeListSaga, app), // Previously app

    forkAutoRestarting(dropdown_sagas.fetchDropdownSaga, app),
    forkAutoRestarting(dropdown_sagas.refreshFormDropdownSaga, app),

    forkAutoRestarting(tax_code_sagas.fetchListTaxCodeSaga, app),
    forkAutoRestarting(tax_code_sagas.deleteTaxCodeFromListSaga, app),
    forkAutoRestarting(tax_code_sagas.saveTaxCodeSaga, app),
    forkAutoRestarting(tax_code_sagas.deleteTaxCodeSaga, app),
    forkAutoRestarting(tax_code_sagas.fetchTaxCodeForEditSaga, app),

    forkAutoRestarting(tax_exempt_type_sagas.fetchListTaxExemptTypeSaga, app),
    forkAutoRestarting(tax_exempt_type_sagas.deleteTaxExemptTypeFromListSaga, app),
    forkAutoRestarting(tax_exempt_type_sagas.saveTaxExemptTypeSaga, app),
    forkAutoRestarting(tax_exempt_type_sagas.deleteTaxExemptTypeSaga, app),
    forkAutoRestarting(tax_exempt_type_sagas.fetchTaxExemptTypeForEditSaga, app),

    forkAutoRestarting(tax_type_sagas.fetchListTaxTypeSaga, app),
    forkAutoRestarting(tax_type_sagas.deleteTaxTypeFromListSaga, app),
    forkAutoRestarting(tax_type_sagas.saveTaxTypeSaga, app),
    forkAutoRestarting(tax_type_sagas.deleteTaxTypeSaga, app),
    forkAutoRestarting(tax_type_sagas.fetchTaxTypeForEditSaga, app),

    forkAutoRestarting(tax_group_sagas.fetchListTaxGroupSaga, app),
    forkAutoRestarting(tax_group_sagas.deleteTaxGroupFromListSaga, app),
    forkAutoRestarting(tax_group_sagas.saveTaxGroupSaga, app),
    forkAutoRestarting(tax_group_sagas.deleteTaxGroupSaga, app),
    forkAutoRestarting(tax_group_sagas.fetchTaxGroupForEditSaga, app),

    forkAutoRestarting(contact_sagas.fetchListContactSaga, app),
    forkAutoRestarting(contact_sagas.deleteContactFromListSaga, app),
    forkAutoRestarting(contact_sagas.saveContactSaga, app),
    forkAutoRestarting(contact_sagas.deleteContactSaga, app),
    forkAutoRestarting(contact_sagas.fetchContactForEditSaga, app),

    forkAutoRestarting(brand_sagas.fetchListBrandSaga, app),
    forkAutoRestarting(brand_sagas.deleteBrandFromListSaga, app),
    forkAutoRestarting(brand_sagas.saveBrandSaga, app),
    forkAutoRestarting(brand_sagas.deleteBrandSaga, app),
    forkAutoRestarting(brand_sagas.fetchBrandForEditSaga, app),

    forkAutoRestarting(matrixattribute_sagas.fetchListMatrixAttributeSaga, app),
    forkAutoRestarting(matrixattribute_sagas.deleteMatrixAttributeFromListSaga, app),
    forkAutoRestarting(matrixattribute_sagas.saveMatrixAttributeSaga, app),
    forkAutoRestarting(matrixattribute_sagas.deleteMatrixAttributeSaga, app),
    forkAutoRestarting(matrixattribute_sagas.fetchMatrixAttributeForEditSaga, app),

    forkAutoRestarting(preference_sagas.fetchByIdPreferenceSaga, app),
    forkAutoRestarting(preference_sagas.fetchListPreferenceSaga, app),
    forkAutoRestarting(preference_sagas.fetchPreferencesWithFilterSaga, app),
    forkAutoRestarting(preference_sagas.savePreferenceSaga, app),
    forkAutoRestarting(preference_sagas.fetchPreferenceSettingsSaga, app),
    forkAutoRestarting(preference_sagas.fetchAllPreferenceSettingsSaga, app),

    forkAutoRestarting(attribute_name_sagas.fetchListAttributeNameSaga, app),
    forkAutoRestarting(attribute_name_sagas.deleteAttributeNameFromListSaga, app),
    forkAutoRestarting(attribute_name_sagas.saveAttributeNameSaga, app),
    forkAutoRestarting(attribute_name_sagas.deleteAttributeNameSaga, app),
    forkAutoRestarting(attribute_name_sagas.fetchAttributeNameForEditSaga, app),

    forkAutoRestarting(attribute_value_sagas.fetchListAttributeValueSaga, app),
    forkAutoRestarting(attribute_value_sagas.deleteAttributeValueFromListSaga, app),
    forkAutoRestarting(attribute_value_sagas.saveAttributeValueSaga, app),
    forkAutoRestarting(attribute_value_sagas.deleteAttributeValueSaga, app),
    forkAutoRestarting(attribute_value_sagas.fetchAttributeValueForEditSaga, app),

    forkAutoRestarting(matrixchildren_sagas.fetchMatrixDetailForEditSaga, app), // Previously app
    forkAutoRestarting(matrixchildren_sagas.generateMatrixItemsSaga, app), // Previously app

    forkAutoRestarting(addErrorMessagesSaga, app), // Previously app

    forkAutoRestarting(supplier_sagas.fetchListSupplierSaga, app),
    forkAutoRestarting(supplier_sagas.deleteSupplierFromListSaga, app),
    forkAutoRestarting(supplier_sagas.saveSupplierSaga, app),
    forkAutoRestarting(supplier_sagas.deleteSupplierSaga, app),
    forkAutoRestarting(supplier_sagas.fetchSupplierForEditSaga, app),

    forkAutoRestarting(credit_type_sagas.fetchListCreditTypeSaga, app),
    forkAutoRestarting(credit_type_sagas.deleteCreditTypeFromListSaga, app),
    forkAutoRestarting(credit_type_sagas.saveCreditTypeSaga, app),
    forkAutoRestarting(credit_type_sagas.deleteCreditTypeSaga, app),
    forkAutoRestarting(credit_type_sagas.fetchCreditTypeForEditSaga, app),

    forkAutoRestarting(credit_certificate_sagas.fetchListCreditCertificateSaga, app),
    forkAutoRestarting(credit_certificate_sagas.fetchCreditCertificateByIdSaga, app),
    forkAutoRestarting(credit_certificate_sagas.saveCreditCertificateSaga, app),
    forkAutoRestarting(credit_certificate_sagas.deleteCreditCertificateSaga, app),

    forkAutoRestarting(print_template_sagas.savePrintTemplateSaga, app),
    forkAutoRestarting(print_template_sagas.fetchPrintTemplateForEditSaga, app),
    forkAutoRestarting(print_template_sagas.deletePrintTemplateSaga, app),
    forkAutoRestarting(print_template_sagas.fetchListPrintTemplateSaga, app),
    forkAutoRestarting(print_template_sagas.previewPrintTemplateSaga, app),

    forkAutoRestarting(promotion_sagas.fetchListPromotionSaga, app),
    forkAutoRestarting(promotion_sagas.savePromotionSaga, app),
    forkAutoRestarting(promotion_sagas.deletePromotionSaga, app),
    forkAutoRestarting(promotion_sagas.fetchPromotionForEditSaga, app),

    forkAutoRestarting(task_sagas.saveTaskSaga, app),
    forkAutoRestarting(task_sagas.fetchTaskForEditSaga, app),
    forkAutoRestarting(task_sagas.fetchTaskListSaga, app),
    forkAutoRestarting(task_sagas.deleteTaskSaga, app),
    forkAutoRestarting(task_sagas.fetchTasks, app),

    forkAutoRestarting(region_sagas.fetchListRegionSaga, app),
    forkAutoRestarting(region_sagas.saveRegionSaga, app),
    forkAutoRestarting(region_sagas.deleteRegionSaga, app),
    forkAutoRestarting(region_sagas.fetchRegionForEditSaga, app),

    forkAutoRestarting(exchange_rate_sagas.fetchListExchangeRateSaga, app),
    forkAutoRestarting(exchange_rate_sagas.saveExchangeRateSaga, app),
    forkAutoRestarting(exchange_rate_sagas.deleteExchangeRateSaga, app),
    forkAutoRestarting(exchange_rate_sagas.fetchExchangeRateForEditSaga, app),

    forkAutoRestarting(price_group_sagas.deletePriceGroupFromListSaga, app),
    forkAutoRestarting(price_group_sagas.deletePriceGroupSaga, app),
    forkAutoRestarting(price_group_sagas.fetchListPriceGroupSaga, app),
    forkAutoRestarting(price_group_sagas.fetchPriceGroupForEditSaga, app),
    forkAutoRestarting(price_group_sagas.savePriceGroupSaga, app),

    forkAutoRestarting(reporting_exchange_rate_sagas.fetchListReportingExchangeRateSaga, app),
    forkAutoRestarting(reporting_exchange_rate_sagas.saveReportingExchangeRateSaga, app),
    forkAutoRestarting(reporting_exchange_rate_sagas.deleteReportingExchangeRateSaga, app),
    forkAutoRestarting(reporting_exchange_rate_sagas.fetchReportingExchangeRateForEditSaga, app),

    forkAutoRestarting(shift_type_sagas.fetchListShiftTypeSaga, app),
    forkAutoRestarting(shift_type_sagas.saveShiftTypeSaga, app),
    forkAutoRestarting(shift_type_sagas.deleteShiftTypeSaga, app),
    forkAutoRestarting(shift_type_sagas.fetchShiftTypeByIdSaga, app),

    forkAutoRestarting(roles_sagas.fetchListRolesSaga, app),
    forkAutoRestarting(roles_sagas.deleteRolesFromListSaga, app),
    forkAutoRestarting(roles_sagas.saveRolesSaga, app),
    forkAutoRestarting(roles_sagas.deleteRolesSaga, app),
    forkAutoRestarting(roles_sagas.fetchRolesForEditSaga, app),
    forkAutoRestarting(roles_sagas.getRoleEmployees, app),

    forkAutoRestarting(classification_sagas.fetchListClassificationSaga, app),
    forkAutoRestarting(classification_sagas.deleteClassificationFromListSaga, app),
    forkAutoRestarting(classification_sagas.saveClassificationSaga, app),
    forkAutoRestarting(classification_sagas.deleteClassificationSaga, app),
    forkAutoRestarting(classification_sagas.fetchClassificationForEditSaga, app),

    forkAutoRestarting(job_sagas.fetchListJobSaga, app),
    forkAutoRestarting(job_sagas.viewJobDetailsSaga, app),
    forkAutoRestarting(job_sagas.deleteJobFromListSaga, app),
    forkAutoRestarting(job_sagas.deleteJobSaga, app),

    forkAutoRestarting(inventory_transfer_sagas.fetchListInventoryTransferSaga, app),
    forkAutoRestarting(inventory_transfer_sagas.saveInventoryTransferSaga, app),
    forkAutoRestarting(inventory_transfer_sagas.getInventoryTransferSaga, app),
    forkAutoRestarting(inventory_transfer_sagas.initializeMassInventoryTransferSaga, app),
    forkAutoRestarting(inventory_transfer_sagas.getInventoryTransferLineItemLocationSaga, app),
    forkAutoRestarting(inventory_transfer_sagas.getPreferencesByFromLocationSaga, app),
    forkAutoRestarting(inventory_transfer_sagas.getAllInventoryTransferLinesItemLocationSaga, app),
    forkAutoRestarting(inventory_transfer_sagas.selectLinesByStatusSaga, app),
    forkAutoRestarting(inventory_transfer_sagas.setLinesReceivedQuantitySaga, app),

    forkAutoRestarting(inventory_adjustment_sagas.getInventoryAdjustmentSaga, app),
    forkAutoRestarting(inventory_adjustment_sagas.saveInventoryAdjustmentSaga, app),
    forkAutoRestarting(inventory_adjustment_sagas.fetchListInventoryAdjustmentSaga, app),
    forkAutoRestarting(inventory_adjustment_sagas.getInventoryAdjustmentLineItemLocationSaga, app),
    forkAutoRestarting(inventory_adjustment_sagas.getAllInventoryAdjustmentLinesItemLocationSaga, app),
    forkAutoRestarting(inventory_adjustment_sagas.deleteInventoryAdjustmentSaga, app),
    forkAutoRestarting(inventory_adjustment_sagas.deleteInventoryAdjustmentFromListSaga, app),

    forkAutoRestarting(inventory_stocktake_sagas.getInventoryStocktakeSaga, app),
    forkAutoRestarting(inventory_stocktake_sagas.saveInventoryStocktakeSaga, app),
    forkAutoRestarting(inventory_stocktake_sagas.fetchListInventoryStocktakeSaga, app),
    forkAutoRestarting(inventory_stocktake_sagas.deleteInventoryStocktakeSaga, app),
    forkAutoRestarting(inventory_stocktake_sagas.deleteInventoryStocktakeFromListSaga, app),
    forkAutoRestarting(inventory_stocktake_sagas.getInventoryStocktakeItemLocationsSaga, app),
    forkAutoRestarting(inventory_stocktake_sagas.exportToDoc, app),
    forkAutoRestarting(inventory_stocktake_sagas.importFromDoc, app),

    forkAutoRestarting(country_sagas.fetchListCountrySaga, app),
    forkAutoRestarting(country_sagas.deleteCountryFromListSaga, app),
    forkAutoRestarting(country_sagas.saveCountrySaga, app),
    forkAutoRestarting(country_sagas.deleteCountrySaga, app),
    forkAutoRestarting(country_sagas.fetchCountryForEditSaga, app),

    forkAutoRestarting(sale_transaction_sagas.fetchListSaleTransactionSaga, app),
    forkAutoRestarting(sale_transaction_sagas.getSaleTransactionSaga, app),
    forkAutoRestarting(sale_transaction_sagas.saveSaleTransactionSaga, app),
    forkAutoRestarting(sale_transaction_sagas.fetchSaleTransactionInventorySaga, app),

    forkAutoRestarting(purchase_order_sagas.fetchListPurchaseOrderSaga, app),
    forkAutoRestarting(purchase_order_sagas.getPurchaseOrderSaga, app),
    forkAutoRestarting(purchase_order_sagas.savePurchaseOrderSaga, app),
    forkAutoRestarting(purchase_order_sagas.getPurchaseOrderLineItemLocationSaga, app),
    forkAutoRestarting(purchase_order_sagas.getPurchaseOrderLineTaxGroupSaga, app),
    forkAutoRestarting(purchase_order_sagas.getPurchaseOrderExchangeRateSaga, app),
    forkAutoRestarting(purchase_order_sagas.generatePurchaseReceiptSaga, app),
    forkAutoRestarting(purchase_order_sagas.getAllPurchaseOrderLinesItemLocationSaga, app),
    forkAutoRestarting(purchase_order_sagas.getPurchaseOrderReorderSaga, app),


    forkAutoRestarting(purchase_receipt_sagas.fetchListPurchaseReceiptSaga, app),
    forkAutoRestarting(purchase_receipt_sagas.getPurchaseReceiptSaga, app),
    forkAutoRestarting(purchase_receipt_sagas.savePurchaseReceiptSaga, app),
    forkAutoRestarting(purchase_receipt_sagas.getPurchaseReceiptLineItemLocationSaga, app),
    forkAutoRestarting(purchase_receipt_sagas.getAllPurchaseReceiptLinesItemLocationSaga, app),
    forkAutoRestarting(purchase_receipt_sagas.getPurchaseReceiptLineTaxGroupSaga, app),
    forkAutoRestarting(purchase_receipt_sagas.getPurchaseReceiptExchangeRateSaga, app),
    forkAutoRestarting(purchase_receipt_sagas.generateInventoryReturnSaga, app),

    forkAutoRestarting(inventory_return_sagas.fetchListInventoryReturnSaga, app),
    forkAutoRestarting(inventory_return_sagas.getInventoryReturnSaga, app),
    forkAutoRestarting(inventory_return_sagas.saveInventoryReturnSaga, app),
    forkAutoRestarting(inventory_return_sagas.getInventoryReturnLineItemLocationSaga, app),
    forkAutoRestarting(inventory_return_sagas.getAllInventoryReturnLinesItemLocationSaga, app),
    forkAutoRestarting(inventory_return_sagas.getInventoryReturnLineTaxGroupSaga, app),
    forkAutoRestarting(inventory_return_sagas.getInventoryReturnExchangeRateSaga, app),

    forkAutoRestarting(matrix_child_sagas.generateMatrixChildrenSaga, app),
    forkAutoRestarting(matrix_child_sagas.createGeneratedMatrixItemsSaga, app),

    // Payment Transaction
    forkAutoRestarting(payment_transaction_sagas.fetchAllPaymentTransaction, app),
    forkAutoRestarting(payment_transaction_sagas.fetchPaymentTransactionById, app),

    // Entity Purchase Orders, Receipts and Returns
    forkAutoRestarting(entity_purchase_order_sagas.getEntityPurchaseOrdersSaga, app), // Previously app
    forkAutoRestarting(entity_purchase_receipt_sagas.getEntityPurchaseReceiptsSaga, app), // Previously app
    forkAutoRestarting(entity_inventory_return_sagas.getEntityPurchaseReturnsSaga, app), // Previously app

    forkAutoRestarting(initialize_sagas.initializeApp),
    forkAutoRestarting(loggingSagas.logOnlineAuthSuccessSaga, app), // Previously app
    forkAutoRestarting(system_notes_sagas.fetchListSystemNotesSaga, app), // Previously app
    // forkAutoRestarting(pouch.startPouchListenerSaga, app), // Previously app

    forkAutoRestarting(ReportSagas, app),
    forkAutoRestarting(DashboardSagas, app),
    // forkAutoRestarting(IntegrationSagas, app), // Previously app
    forkAutoRestarting(CSVSagas, app),
    forkAutoRestarting(GlobalSearchSagas, app),

    forkAutoRestarting(ExportTransactionSagas, app), // Previously app
    forkAutoRestarting(CSVExportSagas, app),

    forkAutoRestarting(RecordSagas, app),
    forkAutoRestarting(StoreSummarySagas, app),
    forkAutoRestarting(KafkaLogSagas, app),
    forkAutoRestarting(ListsSagas, app),
    forkAutoRestarting(ApiCredentialSagas, app),

    forkAutoRestarting(sendEmailSaga, app),
    forkAutoRestarting(sendSmsSaga, app),
    forkAutoRestarting(item_group_price_sagas, app),
    forkAutoRestarting(unit_of_measure_type_sagas, app),
    forkAutoRestarting(item_uom_sagas, app),
    forkAutoRestarting(item_number_type_sagas, app),
    forkAutoRestarting(ereceiptSagas, app),
    forkAutoRestarting(labelPrintSagas, app),
    forkAutoRestarting(loyalty_redemption_sagas, app),
    forkAutoRestarting(spiSagas, app),
    forkAutoRestarting(xeroSagas, app),
    forkAutoRestarting(integrationSagas, app),
    forkAutoRestarting(event_sagas, app),
    forkAutoRestarting(order_management_sagas, app),
    forkAutoRestarting(order_group_sagas, app),
    forkAutoRestarting(shipping_method_sagas, app),
    forkAutoRestarting(order_management_control_records_sagas, app),
    forkAutoRestarting(shortcut_sagas, app),
    forkAutoRestarting(budgetSagas, app),
  ]);
}

function* addErrorMessagesSaga(app) {
  yield takeEvery('ADD_ERROR_MESSAGES', callAddErrorMessages, app);
}

function* callAddErrorMessages(app, action) {
  const { messages } = action;
  yield common.showErrorSaveRecord(messages);
}

function* saveAsSaga(app) {
  yield takeEvery('SAVE_RECORD_AS', callSaveAs, app);
}
function* callSaveAs(app, action) {
  yield common.showProgressSaveAsRecord();
  try {
    const { id, docType, saveAsUrl, intl } = action;
    let redirectTo = `/admin/${docType}/add`;
    if (saveAsUrl) {
      redirectTo = saveAsUrl;
    }
    browserHistory.push(redirectTo);

    const { tenant, user } = yield select();
    const params = {
      tenant, user,
      id, docType
    };

    let docCopy = yield call(api.getRecordForSaveAs, app, params);

    delete docCopy.reference_id;
    delete docCopy.certificate_id;

    switch (docCopy.doc_type) {
      case DocType.CUSTOM_FIELD: {
        docCopy.field_name = `${docCopy.field_name}_copy`;
        break;
      }

      case DocType.PURCHASE_ORDER: {
        docCopy = yield call(purchase_order_sagas.getPurchaseOrderCopy, app, { data: docCopy });
        break;
      }

      case DocType.HOTKEY_GROUP:{
        docCopy.hotkey_group_items = docCopy.hotkey_group_items.map(item => (
          item.hotkey_group_item_id
        ));
        docCopy.is_class = docCopy.is_class.toString();
        break;
      }

      case DocType.INVENTORY_TRANSFER:
      case DocType.INVENTORY_MOVEMENT_CONTROL: {
        docCopy = yield handleInventoryCopy(docCopy);
        break;
      }

      case DocType.LOCATION: {
        const { sub_location_mapping } = docCopy;
        const subLocationKeys = Object.keys(sub_location_mapping);
        (subLocationKeys || []).forEach(subLocationKey => {
          if (typeof sub_location_mapping[subLocationKey] === 'object' && !isEmpty(sub_location_mapping[subLocationKey])) {
            const { location_type_id, is_physical_location } = sub_location_mapping[subLocationKey];
            docCopy[`${subLocationKey}_mapped_location_type`] = location_type_id;
            docCopy[`${subLocationKey}_is_physical_location`] = is_physical_location;
          }
        });
        break;
      }

      case DocType.SUBSIDIARY: {
        if (docCopy.primary_subsidiary) {
          docCopy.primary_subsidiary = false;
        }
        break;
      }

      case DocType.PRICEBOOK: {
        delete docCopy.price_book_reference;
        (docCopy.price_levels || []).forEach(priceLevel => {
          delete priceLevel.id;
          delete priceLevel._id;
          (priceLevel.quantity_break || []).forEach(quantityBreak => {
            delete quantityBreak.id;
            delete quantityBreak._id;
            delete quantityBreak.price_book_price_level_id;
          });
        });

        if(docCopy.tax_group_id){
          yield put({ type: 'GET_PRICEBOOK_TAX_CODE', tax_group_id: docCopy.tax_group_id });
        }

        docCopy.margin_percent = Number(docCopy.margin_percent);
        docCopy.mark_up_percent = Number(docCopy.mark_up_percent);
        const isMargin = !!docCopy.margin_percent;
        docCopy.use_margin = isMargin;
        break;
      }

      case DocType.PROMOTION: {
        delete (docCopy.value_promotion || {}).id;
        ((docCopy.value_promotion || {}).criteria || []).forEach(criteria => {
          delete criteria.id;
          delete criteria._id;
        });

        delete (docCopy.product_promotion || {}).id;
        ((docCopy.product_promotion || {}).criteria || []).forEach(criteria => {
          delete criteria.id;
          delete criteria._id;
        });

        delete ((docCopy.product_promotion || {}).product_impacted || {}).id;

        (docCopy.exempts || []).forEach(exempt => {
          delete exempt.id;
          delete exempt._id;
        });

        break;
      }

      case DocType.DEVICE: {
        const deviceStatusList = yield select(getStatusList);
        const closedStatusId = deviceStatusList.find(status => status.cid === DeviceStatus.CLOSED).id;

        delete docCopy.signature_id;
        delete docCopy.signature;
        docCopy.status_id = closedStatusId;

        break;
      }

      case DocType.LABEL_PRINT: {
        delete docCopy.label_print_lines_ids;
        docCopy.label_print_lines = docCopy
          .label_print_lines
          .map(({ item_id, count }) => ({
            item_id,
            count,
          }));

        break;
      }

      default: break;
    }

    yield common.doneSaveAsRecord(docCopy);
    yield common.doneDataById(docCopy, intl.formatMessage(messagesCommon.sagas_saveAs), true);

    // Post-fetch and set
    switch (docCopy.doc_type) {
      case DocType.PURCHASE_ORDER:
        yield put(getAllPurchaseOrderLinesItemLocation(docCopy.location_id));
        break;

      default:
        break;
    }
  } catch (error) {
    yield common.showErrorSaveAsRecord(error);
  }
}

function* handleInventoryCopy(docCopy) {
  docCopy.status._id = TransactionStatus.OPEN;
  delete docCopy.transaction_reference;
  delete docCopy.run_status;
  delete docCopy.created_by;
  delete docCopy.created_datetime;
  delete docCopy.authorised_by;
  delete docCopy.authorised_date;
  delete docCopy.reference_id;

  docCopy.lines = docCopy.lines.map(line => {
    line.status._id = InventoryStatus.PENDING;
    delete line.next_status;

    if (docCopy.doc_type === DocType.INVENTORY_TRANSFER) {
      delete line.received_code;
      delete line.received_comment;
      delete line.quantity_receive;
    }

    return line;
  });

  switch (docCopy.doc_type) {
    case DocType.INVENTORY_MOVEMENT_CONTROL:
      yield put({ type: ActionType.SET_INVENTORY_ADJUSTMENT, data: { ...docCopy } });
    break;

    case DocType.INVENTORY_TRANSFER:
      yield put({ type: ActionType.SET_INVENTORY_TRANSFER, data: { ...docCopy } });
    break;

    default: break;
  }

  return docCopy;
}

function* fetchDataByIdSaga(app) {
  yield takeEvery("FETCH_DATA_BY_ID", callFetchDataById, app);
}
function* callFetchDataById(app, action) {
  const fetchParams = {
    id: action.id,
    docType: action.docType
  }
  const result = yield call(getRecordbyId, app, api.fetchDataById, fetchParams);
  return result;
}


function* findTransactionByLocationSaga(app) {
  yield takeEvery("FIND_TRANSACTION_BY_LOCATION", callFetchTransactionByLocation, app);
}
function* callFetchTransactionByLocation(app, action) {
  const fetchParams = {
    id: action.id
  }
  try {
    const result = yield call(api.getTransactionByLocation, app, fetchParams);
    yield put({ type: "SINGLE_QUERY_RESULT", payload: result });
  } catch (error) {
    console.error("Error in findTransactionByLocationSaga", error);
  }
}

function* getRecordbyId(app, apiFunction, params) {
  const { tenant, user } = yield select();
  try {

    const { id, docType, dontShowProgress, forceRefresh } = params;
    if (!id || !docType) {
      return;
    }

    const time = forceRefresh ? new Date().getTime() : null;

    if (!dontShowProgress) {
      yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, time } });
    }

    /* Call the api */
    const data = yield call(apiFunction, app, {
      tenant,
      user,
      params: { id, docType }
    });

    yield common.doneDataById(data);
    return data;

  } catch (error) {
    console.log('FETCH_DATA_BY_ID_ERROR', error)
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}


function* initializePouchDatabaseSaga(app) {
  yield takeEvery("INIT_POUCH_DATABASE", callInitPouchDb, app);
}
function* callInitPouchDb(app, action) {
  yield put({ type: 'POUCHDB_INIT_INPROGRESS' });
  /* eslint-disable */
  const remoteDb = yield call(api.getCouchSetupDbURL, action.tenant);
  /* eslint-enable */
  for (let localDbName of api.setupDbNames) {
    yield forkAutoRestarting(createSetupDb, remoteDb, localDbName);
  }
  yield put({ type: 'POUCHDB_INIT_DONE' });
}
function* createSetupDb(remoteDb, localDbName) {
  yield call(api.initializePouchDb, remoteDb, localDbName);
}


function* listSetupDataSaga(app) {
  yield takeEvery("SETUP_LIST_DATA", callListSetupData, app);
}
function* callListSetupData(app, action) {
  const { docType } = action;
  yield put({
    type: 'LIST_SETUP_DATA_INPROGRESS',
    isFetching: true,
    docType
  });
  const result = yield call(api.listSetupData, docType);
  let rows = result.rows.map(function (data) {
    return data.doc;
  });
  yield put({
    type: 'LIST_SETUP_DATA_DONE',
    isFetching: false,
    docType,
    rows
  });
}


function* sendEmailSaga(app) {
  yield takeEvery('SEND_EMAIL', callSendEmail, app);
}
function* callSendEmail(app, actions) {
  try {
    const { recipient, message, subject } = actions.payload;

    const opts = {
      subject,
      to: recipient,
      text: message,
    };

    yield fork(email, app, opts);
  } catch (err) {
    console.error('@callSendEmail::error', err);
  }
}

function* sendSmsSaga(app) {
  yield takeEvery('SEND_SMS', callSendSms, app);
}
function* callSendSms(app, actions) {
  const { number, message, id } = actions.payload;
  const { _id: subsidiary } = yield select(getPrimarySubsidiary);

  const opts = {
    destination_number: number,
    content: message,
  };

  const params = {
    id,
    subsidiary,
  };

  // To utilize `fork` behavior, we wrap it to handle errors
  function* fFork() {
    try {
      yield call(...arguments);
      yield common.showMessageDataById('Message sent');
    } catch (err) {
      console.error('@callSendSms::error', err);
      yield common.showErrorSaveRecord(err);
    }
  };

  yield fork(fFork, sms, app, opts, params);
}
